// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2wVgQ","footer":"ModalCreateQualiphyProcedure_footer__4S7RQ","additionData":"ModalCreateQualiphyProcedure_additionData__1VFw6"};